__turbopack_context__.v({
  "h6": "MOH19G_h6",
  "header": "MOH19G_header",
  "headline": "MOH19G_headline",
  "placeholder": "MOH19G_placeholder",
  "text": "MOH19G_text",
});
